export function formatCounter(count) {
  return count > 99 ? '99+' : count.toString();
}
